export default __webpack_public_path__ + "3cf9decb4181798a7987daf21bec454c.png";